<ul class="breadcrumb" *ngIf="environmentSettings.PSS">
    <li>
      <a [routerLink]="['/']">Home</a>
    </li>
    <li>
     Agenda Group
    </li> 
  </ul>
  
  <section class="card">
    <div class="card-header">
      <span class="cat__core__title">
        <strong>Agenda Group </strong>
      </span>
      <span style="float: right">
        <button class="btn btn-sm btn-primary" type="button" data-toggle="modal" data-target="#indexGrouping" (click) = "showAddPopUp()" 
        [appHasPermission]="{'Url': '/agendaGroup/edit?goveva=true&email=', 'method':'put', 'menu': 'AgendaGroup'}">
          <i class="fa fa-plus"></i>&nbsp;Add Group</button>
          
      </span>
    </div>
    <div class="card-block datatable-card-block">
      <div class="row">
        <div class="col-md-12">
          <div class="margin-bottom-50">
  
            <div class="table-responsive">
              <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-hover compact cell-border nowrap stripe"
                id="groupTable" style="cursor: pointer;">
                <thead>
                  <tr>
                    <th>Group Name  </th>
                    <th>Group Number</th>
                    <th class="group-list-action">
                      <span [appHasPermission]="{'Url': '/agendaGroup/edit?goveva=true&email=', 'method':'put', 'menu': 'AgendaGroup'}">Action</span></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let group of indexGroupingList;">
                    <td tabindex="1">{{group.GroupName }}</td>
                    <td tabindex="1">{{group.GroupingNumber }}</td>
                    <td class="group-list-action">
                      <button type="button" class="btn-sm btn btn-warning" (click)="getGroupIndexById(group._id)" [appHasPermission]="{'Url': '/agendaGroup/edit?goveva=true&email=', 'method':'put', 'menu': 'AgendaGroup'}">
                        <span class="fa fa-pencil"></span>
                      </button>&nbsp;&nbsp;&nbsp;
                      <button type="button" class="btn-sm btn btn-danger" (click)="deleteConfirmation(group._id)" [appHasPermission]="{'Url': '/agendaGroup/edit?goveva=true&email=', 'method':'put', 'menu': 'AgendaGroup'}">
                        <span class="icmn-bin"></span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
  
            </div>
  
            <!-- <div class="modal fade modal-size-medium" id="groupDialog" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
              <div class="modal-dialog" role="document">
                <form [formGroup]="groupMasterForm" class="well" (keydown)="keyDownEnterFunction($event)">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="myModalLabel">Tag</h5>
                      <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                        <i class="fa fa-times"></i>
                      </button>
                    </div>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-3">
                          <label class="form-control-label" for="l0">Tag
                            <span _ngcontent-c2="" style="color: red;">*</span>
                          </label>
                        </div>
                        <div class="col-md-9">
                          <div class="form-group">
  
                            <input [formControl]="groupMasterForm.controls['GroupName']" class="form-control" id="groupName">
                            <div *ngIf="groupMasterForm.controls['GroupName'].hasError('required') && groupMasterForm.controls['GroupName'].touched"
                              class="form-control-error-custom">
                              Tag name is required.
                            </div>
                            <div *ngIf="groupMasterForm.controls['GroupName'].hasError('pattern') && groupMasterForm.controls['GroupName'].touched" class="form-control-error-custom">
                              Please enter a valid Tag name.
                            </div>
                          </div>
                        </div>
  
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button id="btnsaveGroup" type="button" class="btn btn-sm btn-primary" [disabled]="!groupMasterForm.valid" (click)="addGroup()">
                        <i class="fa fa-save"></i>Save
                      </button>
                      <button id="btnupdateGroup" style="display:none;" type="button" class="btn btn-sm btn-primary" [disabled]="!groupMasterForm.valid"
                        (click)="editGroup()">
                        <i class="fa fa-save"></i>Update
                      </button>
                      <button type="button" class="btn btn-sm" data-dismiss="modal">
                        <i class="fa fa-times"></i>Close
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div> -->
            <div id="indexGrouping" class="modal fade" role="dialog">
              <div class="modal-dialog">
      
                  <!-- Modal content-->
                  <div class="modal-content">
                      <div class="modal-header">
                          <h4 class="modal-title">Add New</h4>
                          <button type="button" class="close" data-dismiss="modal">&times;</button>
      
                      </div>
                      <div class="modal-body">
                          <div class="row">
                              <div class="col-md-3">
                                  <label class="form-control-label">Grouping Type</label>
                                  <span _ngcontent-c2="" style="color: red;">*</span>
                              </div>
                              <div class="col-md-9">
      
                                  <div class="form-group">
                                      <div class="md-radio md-radio-inline">
                                        <input id="GlobalGroup" type="radio" [(ngModel)]="GroupingIndex" name="GlobalGroup" 
                                            style="padding:6px;" value="GlobalGroup" (click)="setGroupingType('GlobalGroup')">
                                        <label for="GlobalGroup">Global</label>
                                      </div>
                                      <div class="md-radio md-radio-inline">
                                        <input id="CompanyGroup" type="radio" [(ngModel)]="GroupingIndex" name="GlobalGroup" 
                                            style="padding:6px;" value="CompanyGroup" (click)="setGroupingType('CompanyGroup')">
                                        <label for="CompanyGroup">Company</label>
                                      </div>
                                      
                                    <!-- <div class="form-control-error-custom" *ngIf="!GroupingIndex">
                                        Grouping Type is required
                                    </div> -->
                                  </div>
                              </div>
                              <div class="col-md-3">
                                      <label class="form-control-label" for="l0">Grouping Number
                                          <span _ngcontent-c2="" style="color: red;">*</span>
                                      </label>
                                  </div>
                                  <div class="col-md-9">
                                      <div class="form-group">
                                          <input [(ngModel)]='GroupingNumber' class="form-control" required="required" (keydown)="noBlankSpaceAtStart($event)"
                                          (click)="groupingNumberFieldTouched()">
                                          <div class="form-control-error-custom" *ngIf="!GroupingNumber && GroupingNumberTouched == true">
                                              Grouping Number is required
                                          </div>
                                      </div>
          
                                  </div>
                              <div class="col-md-3">
                                  <label class="form-control-label" for="l0">Grouping Name
                                      <span _ngcontent-c2="" style="color: red;">*</span>
                                  </label>
                              </div>
                              <div class="col-md-9">
                                  <div class="form-group">
                                      <input [(ngModel)]='GroupingName' class="form-control" required="required" (keydown)="noBlankSpaceAtStart($event)"
                                      (click)="groupingNameFieldTouched()">
                                      <div class="form-control-error-custom" *ngIf="!GroupingName && GroupingNameTouched == true">
                                          Grouping Name is required
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="modal-footer">
                          <button type="button" class="btn btn-sm btn-primary" [disabled] ='!GroupingIndex || !GroupingName || !GroupingNumber || disabledOnclick' (click)="SaveIndexGrouping()"
                              data-dismiss="modal" *ngIf="addBtn">Save</button>
                              <button type="button" class="btn btn-sm btn-primary" [disabled] ='!GroupingIndex || !GroupingName || !GroupingNumber || disabledOnclick' (click)="updateIndexGrouping()"
                              data-dismiss="modal" *ngIf="!addBtn">Update</button>
                          <button type="button" class="btn btn-sm btn-default" data-dismiss="modal">Close</button>
                      </div>
                  </div>
      
              </div>
          </div>
  
  
            <div class="modal fade" id="confirmation" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="myModalLabelForDelete">
                      <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                  <div class="modal-body">
                    <div class="row">
                      <div class="col-sm-12">
                          Are you sure you want to delete the Group?
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-danger" (click)="deleteAgendaGroup()">
                      <i class="fa fa-check"></i>&nbsp;Yes
                    </button>
                    <button type="button" class="btn btn-sm" data-dismiss="modal">
                      <i class="fa fa-times"></i>&nbsp;No
                    </button>
                  </div>
                </div>
              </div>
            </div>
  
          </div>
        </div>
      </div>
    </div>
  </section>
  <app-alert></app-alert>